import React from 'react';
import { IconButton as MuiIconButton } from '@mui/material';
import { BtnColor, BtnSize, StyleOverrides } from '~/index.ts';
import { OverridableStyles } from '~/utils/types.ts';
import { IconProps } from '../Icon/types.ts';

export interface IconButtonProps extends OverridableStyles {
  IconComponent: React.FC<IconProps>;
  iconStyleOverrides?: StyleOverrides;
  color?: BtnColor;
  disabled?: boolean;
  dataTestId?: string;
  size?: BtnSize;
  onClick?: (e: React.MouseEvent) => void;
}

const IconButtonRenderer: React.ForwardRefRenderFunction<
  HTMLButtonElement,
  IconButtonProps
> = (
  {
    dataTestId,
    IconComponent,
    size,
    styleOverrides,
    iconStyleOverrides,
    ...buttonPassthroughProps
  },
  ref,
) => (
  <MuiIconButton
    data-test-id={dataTestId}
    size={size}
    sx={styleOverrides}
    ref={ref}
    {...buttonPassthroughProps}
  >
    <IconComponent
      {...(iconStyleOverrides ? { styleOverrides: iconStyleOverrides } : {})}
      fontSize={size}
    />
  </MuiIconButton>
);

const IconButton = React.forwardRef(IconButtonRenderer);

export default IconButton;
